import React, { useEffect, useState } from "react";
import { apiGetSpaces } from "../../../api/ApiSpace";
import { useSelector } from "react-redux";
import { apiGetCalendrierOrgunit } from "../../../api/ApiGraph";
import ComponentLoader from "../../layout/ComponentLoader";
import { useTranslation } from "react-i18next";

const CompomentOrgunitCalendrier = (props) => {
  const { t } = useTranslation();
  const { nomOrgunit, reduxInstanceId, enfantsOrgunit } = props;
  const { ReduxTokenApiGraph } = useSelector((state) => state.ReduxToken);
  const [agendaComite, setAgendaComite] = useState();
  const [loader, setLoader] = useState(false);

  const recupCalendriers = async (espaces) => {
    // si l'instance permet de récupérer les calendriers des salles
    // calcul pour prendre la semaine en cours + 4 semaines avant jusqu'au lundi
    let debut = new Date();
    debut = debut.setUTCDate(debut.getUTCDate() - debut.getUTCDay() - 27);
    debut = new Date(debut);
    debut = debut.toLocaleDateString("fr");
    let decoupageDebut = debut.split("/");
    let debutFormat = decoupageDebut[2] + "-" + decoupageDebut[1] + "-" + decoupageDebut[0];

    // calcul pour prendre la semaine en cours + 4 semaines derriere jusqu'au vendredi
    let fin = new Date();
    fin = fin.setUTCDate(fin.getUTCDate() - fin.getUTCDay() + 26);
    fin = new Date(fin);
    fin = fin.toLocaleDateString("fr");
    let decoupageFin = fin.split("/");
    let finFormat = decoupageFin[2] + "-" + decoupageFin[1] + "-" + decoupageFin[0];

    let formdata = new FormData();
    formdata.append("instance", reduxInstanceId);
    formdata.append("vue", "orgunit");
    formdata.append("orgunits[]", nomOrgunit);
    formdata.append("dateDebut", debutFormat);
    formdata.append("dateFin", finFormat);

    for (var i = 0; i < espaces.length; i++) {
      formdata.append("salles[]", espaces[i].email);
    }

    for (var i = 0; i < enfantsOrgunit.length; i++) {
      formdata.append("orgunits[]", enfantsOrgunit[i].nom);
    }

    const resCalendriers = await apiGetCalendrierOrgunit(ReduxTokenApiGraph, formdata);
    if (resCalendriers.data && resCalendriers.data.data.length) {
      // resCalendriers.data.data[0].agendaComite.sort((a, b) =>
      //   a.dateDebut > b.dateDebut ? 1 : b.dateDebut > a.dateDebut ? -1 : 0,
      // );

      const agendaFusionne = resCalendriers.data.data
        .flatMap((item) => item.agendaComite)
        .sort((a, b) => new Date(a.dateDebut) - new Date(b.dateDebut));

      setAgendaComite(agendaFusionne);

      // setAgendaComite(resCalendriers.data.data[0].agendaComite);
    } else {
      setAgendaComite();
    }
  };

  const RdvComite = (props) => {
    let { rdv, index } = props;
    let dateJour = new Date();
    let ajoutFuseauHoraire = -dateJour.getTimezoneOffset() / 60;

    let isoDateStart = new Date(rdv.dateDebut);
    let isoDateEnd = new Date(rdv.dateFin);
    isoDateStart.setHours(isoDateStart.getHours() + ajoutFuseauHoraire);
    isoDateEnd.setHours(isoDateEnd.getHours() + ajoutFuseauHoraire);
    let startDate = isoDateStart.toLocaleDateString("fr-FR");
    //let endDate = isoDateEnd.toLocaleDateString("fr-FR");
    let startTime = isoDateStart.toLocaleTimeString("fr-FR");
    let endTime = isoDateEnd.toLocaleTimeString("fr-FR");

    let days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

    return (
      <div
        className={
          index % 2 === 0
            ? "rdvComiteTimeline rdvComiteTimelineDecalageDessus"
            : "rdvComiteTimeline rdvComiteTimelineDecalageDessous"
        }
        style={{ left: index * 100 + "px" }}
      >
        <div
          className={
            index % 2 === 0
              ? "rdvComiteTimelinebouletteCalendrier rdvComiteTimelinebouletteCalendrierDessus"
              : "rdvComiteTimelinebouletteCalendrier rdvComiteTimelinebouletteCalendrierDessous"
          }
        ></div>
        {rdv.sujet}
        <br />
        {days[isoDateStart.getDay()]} {startDate.substring(0, startTime.length - 3)} -
        {startTime.substring(0, startTime.length - 3)} à {endTime.substring(0, endTime.length - 3)}
        <br />
        {rdv.salle}
      </div>
    );
  };
  const recupDatas = async () => {
    setLoader(true);
    const resSpaces = await apiGetSpaces(reduxInstanceId, "filter[email][$ne]");
    if (resSpaces.data) {
      const spaces = resSpaces.data.filter((item) => item.email !== "");
      if (spaces.length) {
        await recupCalendriers(spaces);
      }
    }
    setLoader(false);
  };

  useEffect(() => {
    recupDatas();
  }, [nomOrgunit]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: "35px" }}>
      {loader && (
        <div className="d-flex align-items-center">
          <ComponentLoader className="me-2" /> {t("public.componentOrgUnit.rechercheReunion")}
        </div>
      )}
      {!loader && agendaComite && (
        <div className="rdvComiteContainer">
          <div className="lineComite">
            <i className="arrowRightComite"></i>
          </div>
          {agendaComite.map((rdv, index) => (
            <RdvComite rdv={rdv} index={index} key={index} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CompomentOrgunitCalendrier;
